import React from 'react';
import { compose } from '@/utils/story-composer';
import Wave from '../elements/wave';
import BackgroundImageWrapper from '@/components/wrappers/background-image-wrapper';
import Button from '@/components/elements/button';
import { StylingEnums } from '@/enums/styling';

function RowPebbleCorner({ elementProps, content, buttons, backgroundImage, focusX = 50, focusY = 50, pageContext }) {
	const { ButtonEnum } = StylingEnums;
	const backgroundPosition = `${focusX}% ${focusY}%`;
	return (
		<>
			<BackgroundImageWrapper
				{...elementProps}
				backgroundImage={backgroundImage}
				pageContext={pageContext}
				style={{
					backgroundSize: 'cover',
					backgroundPosition,
				}}
			>
				<div className="w-full h-70 md:h-80 lg:h-auto 3xl:h-200 overflow-hidden">
					<section className="pb-20 container hidden lg:block">
						<svg
							className="hidden lg:block lg:-mt-72 lg:-ml-64 xl:-ml-72 2xl:h-200 3xl:h-240 3xl:-mt-80 3xl:-ml-48"
							width="826px"
							height="703px"
							viewBox="0 0 826 703"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="Pebbles-Copy" transform="translate(0.564203, 0.606463)">
									<path
										d="M244.692022,22.1477158 C321.676643,-0.147360134 408.049648,-4.29510485 489.837011,3.86995254 C511.392651,6.02191136 531.776119,9.44561349 551.007402,14.0813547 C711.817233,35.9303236 825.435797,130.910198 825.435797,376.071451 C825.435797,430.291114 790.43611,488.470819 735.511465,538.892534 C650.541411,652.502052 495.270808,734.060591 325.987901,688.701372 C62.6172946,618.131431 -40.6045121,445.634469 14.2776293,240.811529 C17.9161632,227.232335 22.2964658,214.325776 27.3616048,202.06808 L27.3519367,202.061386 C41.5570754,89.0987422 132.956101,42.1764177 241.581602,22.6974254 Z"
										id="BG"
										fill="#FFFFFF"
									/>
									<path
										d="M325.987901,688.701372 C589.358507,759.271314 818.812073,522.634488 802.388435,336.050123 C785.964797,149.465759 686.868915,23.5401895 489.837011,3.86995254 C292.805107,-15.8002844 69.1597708,35.9885882 14.2776293,240.811529 C-40.6045121,445.634469 62.6172946,618.131431 325.987901,688.701372 Z"
										id="Pebble"
										fill="#33A8EB"
										opacity="0.9"
									/>
									<path
										d="M401.008545,673.893537 C198.029435,673.893537 51.4471162,394.051498 33.4823542,306.715623 C-26.887827,13.2253685 265.681501,8.89353735 468.660611,8.89353735 C671.639722,8.89353735 825.435797,90.8384239 825.435797,376.071451 C825.435797,512.454612 603.987656,673.893537 401.008545,673.893537 Z"
										id="Pebble"
										fill="#0D72DB"
										opacity="0.8"
									/>
								</g>
							</g>
							<foreignObject width="100%" height="100%">
								<div className="prose-white lg:mt-60 lg:ml-64 lg:pr-24 lg:pt-20 xl:ml-60 2xl:pt-6 2xl:pr-14 3xl:pt-0 3xl:ml-52 3xl:mt-56 fixed">
									{content}
									<div className="w-full flex mt-12">
										{buttons.map(button => (
											<Button key={button._uid} customClasses="mr-2" {...button} />
										))}
									</div>
								</div>
							</foreignObject>
						</svg>
					</section>
				</div>
				<Wave backgroundColor="bg-white" />
			</BackgroundImageWrapper>
			<div className="container py-10 lg:hidden font-bold prose-midnight">
				{content}
				<div className="w-full flex mt-10 flex-row">
					{buttons.map(button => {
						if (button.buttonType === ButtonEnum.SECONDARY_WHITE) {
							return (
								<Button
									key={button._uid}
									customClasses="mr-2 w-full"
									{...button}
									buttonType={ButtonEnum.SECONDARY_TREE_POPPY}
								/>
							);
						}
						return <Button key={button._uid} customClasses="mr-2 w-full" {...button} />;
					})}
				</div>
			</div>
		</>
	);
}

compose('row-pebble-corner', RowPebbleCorner, { children: ['content'] });
export default RowPebbleCorner;
